import getBaseUrl from './base-url'

export default function getHttpConfig(userConfig) {
  return {
    baseURL: getBaseUrl(userConfig.urls),
    timeout: 15000,
    withCredentials: true,
  };
}
